/**
 * @generated SignedSource<<fb031c39f6f4d540b36407378bbf5601>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BrandLogoUpdateInput = {
  clientMutationId?: string | null | undefined;
  fileName: string;
};
export type LogoUpdateMutation$variables = {
  input: BrandLogoUpdateInput;
};
export type LogoUpdateMutation$data = {
  readonly brandLogoUpdate: {
    readonly brand: {
      readonly " $fragmentSpreads": FragmentRefs<"Logo_brand">;
    } | null | undefined;
  } | null | undefined;
};
export type LogoUpdateMutation = {
  response: LogoUpdateMutation$data;
  variables: LogoUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LogoUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandLogoUpdatePayload",
        "kind": "LinkedField",
        "name": "brandLogoUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandType",
            "kind": "LinkedField",
            "name": "brand",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "Logo_brand"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LogoUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandLogoUpdatePayload",
        "kind": "LinkedField",
        "name": "brandLogoUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandType",
            "kind": "LinkedField",
            "name": "brand",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ImageType",
                "kind": "LinkedField",
                "name": "logoImage",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "48f507dc7f841d55659c7a391d0755b3",
    "id": null,
    "metadata": {},
    "name": "LogoUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation LogoUpdateMutation(\n  $input: BrandLogoUpdateInput!\n) {\n  brandLogoUpdate(input: $input) {\n    brand {\n      ...Logo_brand\n      id\n    }\n  }\n}\n\nfragment Logo_brand on BrandType {\n  id\n  name\n  logoImage {\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "3f2c1c61b18b06533f96283f3980a963";

export default node;
